<template>
  <RsPartialNavigationContainer
    v-if="hasAnyPermissionOfProperties"
    :key="variant"
  >
    <RsPartialNavigationTree
      title="Properties"
      icon="far fa-home rs-text-tertiary-medium-purple"
      active-icon="fas fa-home rs-text-primary"
      icon-size="lg"
      class="rs-text-white"
      :variant="variant"
      :expanded="expanded"
      :active="routeStartsWith('/properties')"
    >
      <RsPartialNavigationTreeBranch>
        <RsPartialNavigationTree
          title="Property List"
          class="rs-text-white"
          to="/properties"
          :active="(routeStartsWith('/properties') && routeEndsWith('/properties')) || routeParamExists('propertyId')"
          hide-expand-icon
        >
          <RsPartialNavigationTree
            v-if="routeParamExists('propertyId')"
            :key="routeParamExists('propertyId')"
            title="Selected Property"
            class="rs-text-white"
            :title-fetcher="getPropertyTitleFetcher"
            :expanded="!!routeParamExists('propertyId')"
            :active="!!routeParamExists('propertyId')"
          >
            <RsPartialNavigationTreeBranch
              v-if="$rsGlobals.$currentUser.hasPermissionAccess('buildings', 'read', $route.params.propertyId)"
              title="Property Details"
              :to="`/properties/${$route.params.propertyId}/details`"
              :active="routeStartsWith('/properties') && routeEndsWith('single') && !routeParamExists('unitId')"
            />
            <RsPartialNavigationTreeBranch
              v-if="$rsGlobals.$currentUser.hasPermissionAccess('units', 'read', $route.params.propertyId)"
            >
              <RsPartialNavigationTree
                title="Units"
                class="rs-text-white"
                :to="`/properties/${$route.params.propertyId}/unit-types`"
                :active="!!routeParamExists('propertyId') && (routeEndsWith('unit-types') || !!routeParamExists('unitId'))"
                hide-expand-icon
              >
                <RsPartialNavigationTree
                  v-if="routeParamExists('propertyId') && routeParamExists('unitId')"
                  :key="routeParamExists('unitId')"
                  title="Selected Unit"
                  class="rs-text-white"
                  :title-fetcher="getUnitTitleFetcher"
                  :expanded="!!routeParamExists('unitId')"
                  :active="!!routeParamExists('unitId')"
                >
                  <RsPartialNavigationTreeBranch
                    title="Unit Details"
                    :to="`/properties/${$route.params.propertyId}/unit-types/${$route.params.unitId}/details`"
                    :active="!!routeParamExists('unitId') && (routeEndsWith('details'))"
                  />
                  <RsPartialNavigationTreeBranch
                    v-if="$rsGlobals.$currentUser.hasPermissionAccess('building_photos', 'read', $route.params.propertyId)"
                    title="Unit Media"
                    :to="`/properties/${$route.params.propertyId}/unit-types/${$route.params.unitId}/media`"
                    :active="!!routeParamExists('unitId') && routeEndsWith('media')"
                    hide-expand-icon
                  />
                  <RsPartialNavigationTreeBranch
                    v-if="$rsGlobals.$currentUser.hasPermissionAccess('buildings', 'read', $route.params.propertyId)"
                    title="Custom Fields"
                    :to="`/properties/${$route.params.propertyId}/unit-types/${$route.params.unitId}/custom-fields`"
                    :active="!!routeParamExists('unitId') && routeEndsWith('custom-fields')"
                  />
                </RsPartialNavigationTree>
              </RsPartialNavigationTree>
            </RsPartialNavigationTreeBranch>
            <RsPartialNavigationTreeBranch
              v-if="$rsGlobals.$currentUser.hasPermissionAccess('buildings', 'read', $route.params.propertyId)"
              title="Amenities"
              :to="`/properties/${$route.params.propertyId}/amenities`"
              :active="!!routeParamExists('propertyId') && routeEndsWith('amenities') && !routeParamExists('unitId')"
            />
            <RsPartialNavigationTreeBranch
              v-if="$rsGlobals.$currentUser.hasPermissionAccess('building_photos', 'read', $route.params.propertyId)"
              title="Property Media"
              :to="`/properties/${$route.params.propertyId}/media`"
              :active="!!routeParamExists('propertyId') && routeEndsWith('media') && !routeParamExists('unitId')"
            />
            <RsPartialNavigationTreeBranch
              v-if="$rsGlobals.$currentUser.hasAtLeastOneModel('pages') && $rsGlobals.$currentUser.getClientSettingValue('buildings_pages') === 'on'"
              title="Pages"
              :to="`/properties/${$route.params.propertyId}/pages`"
              :active="!!routeParamExists('propertyId') && routeEndsWith('pages') && !routeParamExists('unitId')"
            />
            <RsPartialNavigationTreeBranch
              v-if="$rsGlobals.$currentUser.hasPermissionAccess('buildings', 'read', $route.params.propertyId)"
              title="Custom Content"
              :to="`/properties/${$route.params.propertyId}/custom-content`"
              :active="!!routeParamExists('propertyId') && routeEndsWith('custom-content') && !routeParamExists('unitId')"
            />
            <RsPartialNavigationTreeBranch
              v-if="$rsGlobals.$currentUser.hasPermissionAccess('standard_listings', 'read', $route.params.propertyId)"
              title="Custom Tracking"
              :to="`/properties/${$route.params.propertyId}/custom-tracking`"
              :active="!!routeParamExists('propertyId') && routeEndsWith('custom-tracking') && !routeParamExists('unitId')"
            />
          </RsPartialNavigationTree>
        </RsPartialNavigationTree>
      </RsPartialNavigationTreeBranch>
      <RsPartialNavigationTreeBranch
        v-if="$rsGlobals.$currentUser.hasAtLeastOneModel('units')"
        title="All Units"
        :to="`/properties/unit-types`"
        :active="routeIncludes('/properties/unit-types')"
      />
      <RsPartialNavigationTreeBranch
        v-if="$rsGlobals.$currentUser.hasAtLeastOneModel('promotions')"
        title="Promotions"
        :to="`/properties/promotions`"
        :active="routeIncludes('/properties/promotions')"
      />
      <RsPartialNavigationTreeBranch
        v-if="$rsGlobals.$currentUser.hasAtLeastOneModel('quick_update') || $rsGlobals.$currentUser.hasAtLeastOneModel('promotions')"
      >
        <RsPartialNavigationTree
          title="Quick Update"
          :active="routeIncludes('/properties/quick-updates')"
          :expanded="routeIncludes('/properties/quick-updates')"
          :locked="$rsGlobals.$isQuickUpdateDisabled"
        >
          <RsPartialNavigationTreeBranch
            v-if="$rsGlobals.$currentUser.hasAtLeastOneModel('units', 'update') && $rsGlobals.$currentUser.hasAtLeastOneModel('quick_update', 'update')"
            title="Rent & Availability"
            :to="`/properties/quick-updates/rates-availability`"
            :active="routeIncludes('/properties/quick-updates/rates-availability')"
          />
          <RsPartialNavigationTreeBranch
            v-if="$rsGlobals.$currentUser.hasAtLeastOneModel('promotions')"
            title="Promotions"
            :to="`/properties/quick-updates/promotions-quick`"
            :active="routeIncludes('/properties/quick-updates/promotions-quick')"
          />
          <RsPartialNavigationTreeBranch
            title="Contact Information"
            :to="`/properties/quick-updates/contact-info`"
            :active="routeIncludes('/properties/quick-updates/contact-info')"
          />
          <RsPartialNavigationTreeBranch
            v-if="$rsGlobals.$currentUser.hasAtLeastOneModel(['standard_listings'])"
          >
            <RsPartialNavigationTree
              title="Custom Tracking"
              :active="routeIncludes('/properties/quick-updates/custom-tracking')"
              :expanded="routeIncludes('/properties/quick-updates/custom-tracking')"
            >
              <RsPartialNavigationTreeBranch
                title="Custom URLs"
                :to="`/properties/quick-updates/custom-tracking-url`"
                :active="routeIncludes('/properties/quick-updates/custom-tracking-url')"
              />
              <RsPartialNavigationTreeBranch
                title="Custom Phone Number"
                :to="`/properties/quick-updates/custom-tracking-phone`"
                :active="routeIncludes('/properties/quick-updates/custom-tracking-phone')"
              />
              <RsPartialNavigationTreeBranch
                title="Custom Emails"
                :to="`/properties/quick-updates/custom-tracking-email`"
                :active="routeIncludes('/properties/quick-updates/custom-tracking-email')"
              />
            </RsPartialNavigationTree>
          </RsPartialNavigationTreeBranch>
        </RsPartialNavigationTree>
      </RsPartialNavigationTreeBranch>
      <RsPartialNavigationTreeBranch
        v-if="$rsGlobals.$currentUser.hasAtLeastOneModel('maintenance')"
        title="Maintenance"
        to="/properties/maintenance-requests"
        :active="routeIncludes('/properties/maintenance-requests')"
      />
      <RsPartialNavigationTreeBranch
        v-if="$rsGlobals.$currentUser.hasAtLeastOneModel('listing_scores')"
        title="Listing Score"
        to="/properties/listing-scores"
        :active="routeIncludes('/properties/listing-scores')"
        :locked="$rsGlobals.$hasClientSettingValue('disable_listing_score', '1')"
      />
    </RsPartialNavigationTree>
  </RsPartialNavigationContainer>
</template>
<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { ISuiteTypes } from '@llws/lift-entity-interfaces';
import {
  routeStartsWith,
  routeParamExists,
  routeEndsWith,
  routeIncludes,
} from '@/shared/helpers/navigation-active-helpers';
import RsPartialNavigationContainer from '@/components/RsPartialNavigationContainer.vue';
import RsPartialNavigationTree, { NavigationTreeVariantType } from '@/components/RsPartialNavigationTree.vue';
import RsPartialNavigationTreeBranch from '@/components/RsPartialNavigationTreeBranch.vue';
import properties from '@/shared/services/properties';
import { decodeHtml } from '@/shared';

const childPerms: string[] = [
  'buildings',
  'listing_scores',
  'units',
  'quick_update',
  'promotions',
  'building_photos',
  'maintenance',
  'pages',
  'standard_listings',
];

export default defineComponent({
  name: 'RsPartialNavProperties',
  components: {
    RsPartialNavigationContainer,
    RsPartialNavigationTree,
    RsPartialNavigationTreeBranch,
  },
  props: {
    variant: {
      type: String as PropType<NavigationTreeVariantType>,
      default: 'collapse',
    },

    expanded: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasAnyPermissionOfProperties(): boolean {
      return childPerms.some((perm) => this.$rsGlobals.$currentUser.hasAtLeastOneModel(perm) || this.$rsGlobals.$userHasAccess(perm));
    },
  },
  methods: {
    routeStartsWith,
    routeEndsWith,
    routeParamExists,
    routeIncludes,
    async getPropertyTitleFetcher(): Promise<string> {
      if (this.$route.params.propertyId) {
        const building = await properties.getByIdV2(Number(this.$route.params.propertyId as string));
        return decodeHtml(building.data?.buildingName || '');
      }
      return '';
    },
    async getUnitTitleFetcher(): Promise<string> {
      if (this.$route.params.unitId && this.$route.params.propertyId) {
        const units = (await properties.getUnits(Number(this.$route.params.propertyId)))?.data ?? [];
        return decodeHtml(units.find((u: ISuiteTypes) => `${u.id}` === this.$route.params.unitId)?.typeName ?? '');
      }

      return '';
    },
  },
});

</script>
